// extracted by mini-css-extract-plugin
module.exports = {"root":"SignupRightSection_root__yQb6d","onboardingImage":"SignupRightSection_onboardingImage__xex4l"};